import React from 'react'
import UbliqueToggle from '@ublique/components/Toggle'


const PivotToggle = ({ isSuperuser, enabledLabel, disabledLabel, pivotValue, onChange }) => {
    


    return (
        <>
        {isSuperuser ? 
            <span className='enable-pivot-toggle'>
                <UbliqueToggle
                    id='enablePivotToggle'
                    labelA={disabledLabel}
                    labelB={enabledLabel}
                    toggled={pivotValue}
                    onToggle={onChange}
                    disabled={!isSuperuser}
                />
            </span> 
           : <span className='enable-pivot-label'>{pivotValue ? enabledLabel : disabledLabel}
        </span>}
        </>
        )
    

}

export default PivotToggle
